import {
  COMBO_CHANNEL,
  CIRCLES1_CHANNEL,
  CIRCLESLARPU,
  SELF_ACTIVATION_SIM,
  ROOT_CHANNEL,
  PHONE_ONLY_CHANNEL,
  FAMILY_PLAN,
  paths,
  forms,
  CIRCLES10_CHANNEL,
  CIRCLES25_CHANNEL,
  CIRCLES45_CHANNEL,
  CIRCLES55_CHANNEL
} from "utils/constants";
import { flattenObject, removeSensitiveData } from "utils/helpers";
import get from "lodash/get";

//After adding Analytics files in the folder under src/analytics/type then add it's constant here also
export const ANALYTICS_TYPES = {
  adobe: "AdobeAnalytics",
  cleverTap: "CleverTapAnalytics"
};

export const ANALYTICS_EVENT_TYPES = {
  TRACK_PAGE: "TRACK_PAGE",
  TRACK_EMAIL_SUBMITTED: "TRACK_EMAIL_SUBMITTED",
  UPDATE_TRANSACTION: "UPDATE_TRANSACTION",
  UPDATE_PAGE_DATA: "UPDATE_PAGE_DATA",
  PUSH_PROFILE: "PUSH_PROFILE",
  PUSH_EVENT: "PUSH_EVENT"
};

export const ANALYTICS_EVENT_STEPS = {
  START: "START",
  FINISH: "FINISH"
};

export const SATELLITE_EVENTS = {
  PURCHASE: "PURCHASE",
  CHARGED: "CHARGED",
  SADPURCHASE: "SADPURCHASE",
  ACTIVATE: "ACTIVATE",
  MYINFO: "MYINFO"
};

// country: { channel: { // put in your params to compare and exclude the flow } }
export const FLOW_EXCLUDE_MAPPING = {
  sg: {}
};

export const ADOBE_EVENTS_MAPPING = {
  planService_api_call_succeeded: {
    category: "PLAN",
    event: "prodView"
  },
  numbers_api_call_succeeded: {
    category: "Number",
    event: "number selection",
    object: "selected_number"
  },
  selectedAddons_requested: {
    true: {
      category: "AddonSelected",
      event: "addons selected",
      object: "addon"
    },
    false: {
      category: "AddonUnselected",
      event: "addons unselected",
      object: "addon"
    }
  },
  PersonalDetailsForm_submitted: {
    event: "personal details",
    transaction: true
  },
  PhonesForm_submitted: {
    event: "phone details",
    transaction: true
  },
  DeliveryInfoForm_submitted: {
    event: "delivery-info"
  },
  order_api_call_succeeded: {
    event: "order-summary",
    transaction: true
  },
  // payment v3, can be removed when payment is fully migrated
  paymentReturn_api_call_succeeded: {
    event: "purchase",
    trackEvent: SATELLITE_EVENTS.PURCHASE, // This will track purchase event through satellite
    transaction: false, // We should not set digitalData.transaction anymore
    object: "order_product_info"
  },
  // payment v4, new api call for payment
  paymentStatus_api_call_succeeded: {
    event: "purchase",
    trackEvent: SATELLITE_EVENTS.PURCHASE, // This will track purchase event through satellite
    transaction: false // We should not set digitalData.transaction anymore
  },
  selfActivationDeliveryOrder_api_call_succeeded: {
    event: "purchase",
    trackEvent: SATELLITE_EVENTS.SADPURCHASE,
    transaction: true
  },
  activateSimCard_api_call_succeeded: {
    event: "activate",
    trackEvent: SATELLITE_EVENTS.ACTIVATE,
    transaction: true
  },
  MyInfoEvent_requested: {
    event: "click",
    trackEvent: SATELLITE_EVENTS.MYINFO
  }
};

export const ADOBE_PROFILE_MAPPING = {
  email: {
    event: "Email Submitted",
    getData: formValues => {
      return {
        email_address: formValues.email,
        profile_source: "ecomm"
      };
    }
  },
  contact_number: {
    event: "ContactNo Submitted",
    getData: formValues => {
      return {
        contact_number: formValues.contact_number,
        profile_source: "ecomm"
      };
    }
  },
  delivery_hse_blk_tower: {
    event: "Delivery House Block Tower Submitted"
  }
};

export const CLEVERTAP_EVENTS = {
  CHARGED: "Charged",
  PROFILE: "Profile",
  SELECTED_PROMOTION: "selected_promotion",
  PROMOTION_STATUS: "promocode_used",
  SELECTED_NUMBER: "selected_number",
  SELECTED_NUMBER_PORT_IN: "selected_number_port_in",
  GUEST_ORDER_CLICK: "Clicked",
  PLAN_SELECTED: "plan_selected",
  CATEGORY_SELECTED: "category_selected",
  POSTPAID_ADDON_SELECTED: "postpaid_addon_selected",
  POSTPAID_ADDON_DESELECTED: "postpaid_addon_deselected",
  ADDON_SELECTED: "addon_selected",
  ADDON_DESELECTED: "addon_deselected",
  PREPAID_ADDON_DELETED: "prepaid_addon_deleted",
  EMAIL_SIGNUP_SUBMIT: "submit_email",
  FIELD_TYPE_SELECTED: "{field}_selected",
  PURCHASE_FLOW_STARTED: "purchase_flow_started",
  VERIFICATION_OTP_SUBMITTED: "verification_submitted",
  ORDER_SUMMARY_COMPLETED: "order_summary_completed",
  KYC_REQUESTED: "confirm_your_identity",
  SIM_NUMBER_TYPE_SELECTED: "sim_number_type_selected",
  USER_DETAILS_SUBMITTED: "user_details_submitted",
  PREPAID_PACKAGE_SELECTED: "prepaid_package_selected",
  PLAN_SELECTED_2: "plan_selected_2",
  PAYMENT_DETAILS_SUBMITTED: "payment_details_submitted",
  ORDER_CONFIRMATION: "order_confirmation",
  TAP: "tap",
  KYC_STARTED: "kyc_started",
  KYC_SUBMITTED: "kyc_submitted",
  ACTIVATION_INITIATION: "activation_initiation"
};

export const CLEVERTAP_ALLOWED_EVENTS = [
  "page_visit",
  "selected_promotion",
  "referralCode_api_call_succeeded",
  "promotion_status",
  "verifyIdentity_api_call_succeeded",
  "selectedAddons_requested",
  "selected_number_port_in",
  "selected_number",
  "ecomm_contact_number_entered",
  "ecomm_email_entered",
  "PersonalDetailsForm_submitted",
  "Charged",
  "validateIccId_api_call_succeeded",
  "validateIccId_api_call_requested",
  "guestOrder_api_call_succeeded",
  "selfActivationDeliveryOrder_api_call_succeeded",
  "paymentReturn_api_call_succeeded",
  "paymentStatus_api_call_succeeded",
  "simActivated_requested",
  "postpaid_planService_requested",
  "postpaid_addon_selected",
  "addon_selected",
  "addon_deselected",
  "userLoginOTP_api_call_succeeded",
  "number_type_selected",
  "sim_type_selected",
  "telco_selected",
  "payment_method_selected",
  "eligiblePlans_api_call_succeeded",
  "userAuthenticate_api_call_succeeded",
  "userAuthenticate_api_call_failed",
  "numberAndDeliverySlotsAvailability_api_call_succeeded",
  "kyc_api_call_succeeded",
  "category_selected",
  "prepaid_addon_deleted",
  "sim_number_type_selected",
  "PreCheckoutForm_submitted",
  "selectedNumberType_requested",
  "manualEkyc_api_call_succeeded",
  "eligiblePlans_api_call_requested",
  "faq_item_clicked"
];

export const PAGE_URLS = {
  PURCHASE_PLAN: "/web/pre-checkout"
};

export const FACEBOOK_ACTION_TYPE = {
  track: "track"
};

export const FB_EVENTS_NAME = {
  INITIATE_CHECKOUT: "InitiateCheckout",
  ADD_PAYMENT_INFO: "AddPaymentInfo",
  PURCHASE: "Purchase",
  COMPLETE_REGISTRATION: "CompleteRegistration"
};

export const GTM_ECOMMERCE_EVENT_NAMES = {
  VIEW_ITEM_LIST: "view_item_list",
  SELECT_ITEM: "select_item",
  VIEW_ITEM: "view_item",
  ADD_TO_CART: "add_to_cart",
  BEGIN_CHECKOUT: "begin_checkout",
  ADD_SHIPPING_INFO: "add_shipping_info",
  PURCHASE: "purchase",
  PLACE_ORDER: "place_order",
  PERSONAL_DETAIL_FORM_START: "personal_detail_form_start",
  PERSONAL_DETAIL_FORM_COMPLETE: "personal_detail_form_complete",
  DELIVERY_DETAIL_FORM_START: "delivery_detail_form_start",
  DELIVERY_DETAIL_FORM_COMPLETE: "delivery_detail_form_complete",
  CONTACT_NO_SUBMITTED: "contact_no_submitted",
  EMAIL_SUBMITTED: "email_submitted",
  VERIFY_EMAIL_CLICK: "verify_email_click",
  OTP_SUBMITTED_EMAIL: "otp_submitted_email",
  EMAIL_INPUT_COMPLETE: "email_input_complete",
  CNIC_SUBMITTED: "cnic_submitted",
  NATIONALITY_SUBMITTED: "nationality_submitted",
  USER_LOGGED_IN: "user_logged_in",
  OTP_SUBMITTED: "otp_submitted",
  NUMBER_TYPE_SELECTED: "number_type_selected",
  SIM_TYPE_SELECTED: "sim_type_selected",
  ADD_ON_SELECTED: "add_on_selected",
  ADD_ON_DESELECTED: "add_on_deselected",
  PAYMENT_PENDING: "payment_pending",
  NEW_NUMBER_SEARCH_RESULT: "number_search_result",
  NUMBER_SELECTED: "number_selected",
  PORT_IN_NUMBER_SELECTED: "port_in_number_selected",
  USER_DETAILS_ENTERED: "user_details_entered",
  ADD_KYC_INFO: "add_kyc_info",
  PROMO_CODE_APPLIED: "promo_code_applied",
  USER_DETAILS: "user_details",
  RESEND_OTT_CODE: "resend_verification_code",
  OTP_MODAL_EXPIRE_MODAL_REQUESTED: "otp_expired_modal_requested",
  RETAIL_ICON_CLICK: "retail_icon_click",
  STORE_ID_ENTERED: "storeId_entered",
  SELF_PICKUP_STATION_REQUESTED: "selfPickupStations_api_call_requested",
  SELF_PICKUP_STATION_SUCCEEDED: "selfPickupStations_api_call_succeeded",
  STORE_ID_DELETE_CLICK: "store_id_delete_click",
  STORE_ID_POPUP_CANCEL_CLICK: "store_id_popup_cancel_click",
  PAYMENT_TYPE_SELECTED: "payment_type_selected",
  LINK_YOUR_EASYPAISA_CLICK: "link_your_easypaisa_click",
  ACCESS_LOCATION: "view_location_based_offer",
  ACCESS_LOCATION_CONSET: "location_consent_given"
};

// Lookup for if GA4 event should be fired
export const GA4_WHITELISTED_TRIGGERS = {
  eligiblePlans_api_call_requested: true, //added to call user details the first time when page loads
  eligiblePlans_api_call_succeeded: true,
  prepaid_load_more: true,
  addon_selected: true,
  number_type_selected: true,
  page_visit: true,
  PreCheckoutForm_submitted: true, // user starts checkout flow
  userLoginOTP_api_call_succeeded: true, // user submits email
  userAuthenticate_api_call_succeeded: true, // user successfully submits otp
  loggedInUserDetails_api_call_succeeded: true, // user successfully logs in
  sim_type_selected: true, // user selects sim type
  order_api_call_succeeded: true, // user places an order
  paymentStatus_api_call_succeeded: true, // payment succeeds
  deliverySlots_api_call_succeeded: true, // for when user fills up shipping information
  field_focused: true,
  stop_async_validation: true,
  field_blurred: true,
  field_touch: true,
  update_sync_errors: true,
  nationality_selected: true,
  addon_deselected: true,
  paymentStatus_api_call_requested: true,
  filteredNumbers_api_call_succeeded: true,
  lockedNumber_api_call_succeeded: true,
  validatePortInNumber_api_call_request: false, // changed the variable as it was for clickstream
  validateGuestOtt_api_call_succeeded: true,
  port_number_selected: false, // changed the variable as it was for clickstream
  validatePortInNumber_api_call_failed: false, // changed the variable as it was for clickstream
  validatePortInNumber_api_call_succeeded: false, // changed the variable as it was for clickstream
  isModalView_requested: true,
  requestGuestOtt_api_call_succeeded: true, // added for personal details screen,
  promocodeOrderPreview_api_call_succeeded: true, // added for tracking promocodes
  otp_expired_modal_requested: true, //otp expire modal view
  resend_requestGuestOtt_api_call_succeeded: true,
  retail_icon_click: true,
  storeId_entered: true,
  selfPickupStations_api_call_requested: true,
  selfPickupStations_api_call_succeeded: true,
  store_id_delete_click: true,
  store_id_popup_cancel_click: true,
  validateGuestOtt_api_call_requested: true,
  payment_type_selected: true,
  link_your_easypaisa_click: true,
  access_location_modal: true,
  location_consent_given: true
};

export const BRANCH_STANDARD_EVENT = {
  PURCHASE: "PURCHASE"
};

// Lookup for if Branch IO event should be fired
export const BRANCH_IO_WHITELISTED_TRIGGERS = {
  paymentStatus_api_call_succeeded: true, // payment succeeds
  paymentRequest_api_call_succeeded: true //saved instrument payment succeeds
};

export const FACEBOOK_VALID_COUNTRIES = {
  SG: "sg",
  AU: "au"
};

export const FACEBOOK_EVENTS_MAPPING = {
  // will break when v3 is migrated to v4, remove when we fully migrated payment v4
  page_visit: {
    valid_countries: {
      au: [
        {
          events: [FB_EVENTS_NAME.INITIATE_CHECKOUT],
          trigger_urls: [
            `${paths.PRE_CHECKOUT.replace(ROOT_CHANNEL, CIRCLES10_CHANNEL)}`,
            `${paths.PRE_CHECKOUT.replace(ROOT_CHANNEL, CIRCLES25_CHANNEL)}`,
            `${paths.PRE_CHECKOUT.replace(ROOT_CHANNEL, CIRCLES45_CHANNEL)}`,
            `${paths.PRE_CHECKOUT.replace(ROOT_CHANNEL, CIRCLES55_CHANNEL)}`
          ]
        },
        {
          events: [FB_EVENTS_NAME.ADD_PAYMENT_INFO],
          trigger_urls: [
            `${paths.ORDER_SUMMARY.replace(ROOT_CHANNEL, COMBO_CHANNEL)}`,
            `${paths.ORDER_SUMMARY.replace(ROOT_CHANNEL, CIRCLES10_CHANNEL)}`,
            `${paths.ORDER_SUMMARY.replace(ROOT_CHANNEL, CIRCLES25_CHANNEL)}`,
            `${paths.ORDER_SUMMARY.replace(ROOT_CHANNEL, CIRCLES45_CHANNEL)}`,
            `${paths.ORDER_SUMMARY.replace(ROOT_CHANNEL, CIRCLES55_CHANNEL)}`
          ]
        }
      ],
      sg: [
        {
          events: [FB_EVENTS_NAME.ADD_PAYMENT_INFO],
          trigger_urls: [`${paths.SELF_ACTIVATION_ORDER_SUMMARY}`]
        }
      ]
    }
  },
  // success_page_visit fires on all :channel/success pages
  success_page_visit: {
    valid_countries: {
      sg: [
        {
          events: [FB_EVENTS_NAME.PURCHASE],
          trigger_urls: [
            `${paths.SUCCESS.replace(ROOT_CHANNEL, SELF_ACTIVATION_SIM)}`
          ]
        }
      ]
    }
  },
  PersonalDetailsForm_submitted: {
    valid_countries: {
      au: [
        {
          events: [FB_EVENTS_NAME.COMPLETE_REGISTRATION],
          condition: (data, fbq, action, eventName) => {
            /**
             * facebookpixel event pushed only when second "next" button clicked
             * in /personal-details pages of
             * /:channel/pre-checkout flows
             */
            const eventData = removeSensitiveData(
              flattenData(get(data, "formValues", {}))
            );
            const delivery_slot_id = get(eventData, "delivery_slot_id");
            delivery_slot_id && fbq(action, eventName, data);
          },
          trigger_urls: [
            `${paths.ORDER_SUMMARY.replace(ROOT_CHANNEL, COMBO_CHANNEL)}`,
            `${paths.ORDER_SUMMARY.replace(ROOT_CHANNEL, CIRCLES10_CHANNEL)}`,
            `${paths.ORDER_SUMMARY.replace(ROOT_CHANNEL, CIRCLES25_CHANNEL)}`,
            `${paths.ORDER_SUMMARY.replace(ROOT_CHANNEL, CIRCLES45_CHANNEL)}`,
            `${paths.ORDER_SUMMARY.replace(ROOT_CHANNEL, CIRCLES55_CHANNEL)}`
          ]
        }
      ]
    }
  },
  // will break when v3 is migrated to v4, remove when we fully migrated payment v4
  paymentReturn_api_call_succeeded: {
    valid_countries: {
      au: [
        {
          events: [FB_EVENTS_NAME.PURCHASE],
          trigger_urls: [
            `${paths.PAYMENT_RETURN.replace(ROOT_CHANNEL, COMBO_CHANNEL)}`,
            `${paths.PAYMENT_RETURN.replace(ROOT_CHANNEL, CIRCLES10_CHANNEL)}`,
            `${paths.PAYMENT_RETURN.replace(ROOT_CHANNEL, CIRCLES25_CHANNEL)}`,
            `${paths.PAYMENT_RETURN.replace(ROOT_CHANNEL, CIRCLES45_CHANNEL)}`,
            `${paths.PAYMENT_RETURN.replace(ROOT_CHANNEL, CIRCLES55_CHANNEL)}`
          ]
        }
      ],
      sg: [
        {
          events: [FB_EVENTS_NAME.PURCHASE],
          trigger_urls: [
            // for ":channel/sa_delivery" ESIM flows
            `${paths.PAYMENT_RETURN.replace(ROOT_CHANNEL, CIRCLES1_CHANNEL)}`,
            `${paths.PAYMENT_RETURN.replace(ROOT_CHANNEL, CIRCLESLARPU)}`,
            // phoneonly flow
            `${paths.PAYMENT_RETURN.replace(ROOT_CHANNEL, PHONE_ONLY_CHANNEL)}`
          ]
        }
      ]
    }
  },
  // new payment call for payment v4
  paymentStatus_api_call_succeeded: {
    valid_countries: {
      au: [
        {
          events: [FB_EVENTS_NAME.PURCHASE],
          trigger_urls: [
            `${paths.PAYMENT_RETURN.replace(ROOT_CHANNEL, COMBO_CHANNEL)}`,
            `${paths.PAYMENT_RETURN.replace(ROOT_CHANNEL, CIRCLES10_CHANNEL)}`,
            `${paths.PAYMENT_RETURN.replace(ROOT_CHANNEL, CIRCLES25_CHANNEL)}`,
            `${paths.PAYMENT_RETURN.replace(ROOT_CHANNEL, CIRCLES45_CHANNEL)}`,
            `${paths.PAYMENT_RETURN.replace(ROOT_CHANNEL, CIRCLES55_CHANNEL)}`
          ]
        }
      ]
    }
  }
};

export const GTM_DATALAYER_FACEBOOK_EVENT_TYPES = {
  CONVERSION: "facebook_conversion_event",
  ACTIVATION: "fb_activation_event"
};

export const GTM_DATALAYER_FACEBOOK_EVENT_MAPPING = {
  // will break when v3 is migrated to v4, remove when we fully migrated payment v4
  paymentReturn_api_call_succeeded: {
    valid_countries: {
      sg: [
        {
          formType: forms.DELIVERY_INFO_FORM,
          dataLayerEventType: GTM_DATALAYER_FACEBOOK_EVENT_TYPES.CONVERSION,
          trigger_urls: [
            `${paths.PAYMENT_RETURN.replace(ROOT_CHANNEL, PHONE_ONLY_CHANNEL)}`
          ]
        },
        {
          // for ":channel/sa_delivery" ESIM flows
          formType: forms.PERSONAL_DETAILS_FORM,
          dataLayerEventType: GTM_DATALAYER_FACEBOOK_EVENT_TYPES.CONVERSION,
          trigger_urls: [
            `${paths.PAYMENT_RETURN.replace(ROOT_CHANNEL, CIRCLES1_CHANNEL)}`,
            `${paths.PAYMENT_RETURN.replace(ROOT_CHANNEL, CIRCLESLARPU)}`
          ]
        }
      ]
    }
  },
  // new payment call for payment v4
  paymentStatus_api_call_succeeded: {
    valid_countries: {
      sg: [
        {
          formType: forms.DELIVERY_INFO_FORM,
          dataLayerEventType: GTM_DATALAYER_FACEBOOK_EVENT_TYPES.CONVERSION,
          trigger_urls: [
            `${paths.PAYMENT_RETURN.replace(ROOT_CHANNEL, PHONE_ONLY_CHANNEL)}`
          ]
        },
        {
          // for ":channel/sa_delivery" ESIM flows
          formType: forms.PERSONAL_DETAILS_FORM,
          dataLayerEventType: GTM_DATALAYER_FACEBOOK_EVENT_TYPES.CONVERSION,
          trigger_urls: [
            `${paths.PAYMENT_RETURN.replace(ROOT_CHANNEL, CIRCLES1_CHANNEL)}`,
            `${paths.PAYMENT_RETURN.replace(ROOT_CHANNEL, CIRCLESLARPU)}`
          ]
        }
      ]
    }
  },
  // success_page_visit fires on all :channel/success pages
  success_page_visit: {
    valid_countries: {
      sg: [
        {
          // for "self_activation/sim" flow
          formType: forms.PERSONAL_DETAILS_FORM,
          dataLayerEventType: GTM_DATALAYER_FACEBOOK_EVENT_TYPES.ACTIVATION,
          trigger_urls: [
            `${paths.SUCCESS.replace(ROOT_CHANNEL, SELF_ACTIVATION_SIM)}`
          ]
        }
      ]
    }
  },
  // this API only fires on the page BEFORE order success.
  // therefore the paths here are NOT paths.SUCCESS
  selfActivationDeliveryOrder_api_call_succeeded: {
    valid_countries: {
      sg: [
        {
          // for ":channel/sa_delivery" physical SIM flows
          formType: forms.SELF_ACTIVATION_FORM,
          dataLayerEventType: GTM_DATALAYER_FACEBOOK_EVENT_TYPES.CONVERSION,
          trigger_urls: [
            `${paths.SELF_ACTIVATION_SIM_DELIVERY.replace(
              ROOT_CHANNEL,
              FAMILY_PLAN
            )}`,
            `${paths.SELF_ACTIVATION_SIM_DELIVERY.replace(
              ROOT_CHANNEL,
              CIRCLES1_CHANNEL
            )}`,
            `${paths.SELF_ACTIVATION_SIM_DELIVERY.replace(
              ROOT_CHANNEL,
              CIRCLESLARPU
            )}`
          ]
        }
      ]
    }
  }
};

export const GTM_PAYMENT_METHOD_NAME_MAPPING = {
  jazzcash_text: "PayFast",
  easypaisa_text: "easypaisa wallet",
  card_text: "PayFast",
  other_cards_txt: "PayFast",
  bank_account_text: "PayFast",
  other_wallets_text: "PayFast",
  one_time_payment_text: "EasyPaisa_One_Time_Payment",
  all_mobile_wallets_text: "PayFast",
  unionpay_text: "UnionPay",
  paypak_text: "PayPak",
  link_account_text: "EasyPaisa_Link_Account"
};

/**
 * All ClickStream event names
 */
export const CLICKSTREAM_EVENT_NAMES = {
  PURCHASE_FLOW_STARTED: "purchase_flow_started",
  CATEGORY_SELECTED: "category_selected",
  PLAN_SELECTED: "plan_selected",
  ADDON_SELECTED: "addon_selected",
  ADDON_DESELECTED: "addon_deselected",
  PREPAID_PACKAGE_SELECTED: "prepaid_package_selected",
  PREPAID_ADDON_DELETED: "prepaid_addon_deleted",
  PLAN_SELECTED_2: "plan_selected_2",
  SUBMIT_EMAIL: "submit_email",
  VERIFICATION_SUBMITTED: "verification_submitted",
  SIM_SELECTED: "sim_selected",
  NUMBER_TYPE_SELECTED: "number_type_selected",
  DONOR_TELCO_SELECTED: "donor_telco_selected",
  SIM_NUMBER_TYPE_SElECTED: "sim_number_type_selected",
  USER_DETAILS_SUBMITTED: "user_details_submitted",
  PROMOCODE_USED: "promocode_used",
  ORDER_SUMMARY_COMPLETED: "order_summary_completed",
  PAYMENT_SELECTED: "payment_selected",
  PAYMENT_DETAILS_SUBMITTED: "payment_details_submitted",
  ORDER_CONFIRMATION: "order_confirmation",
  TAP: "tap",
  KYC_STARTED: "kyc_started",
  KYC_SUBMITTED: "kyc_submitted",
  ACTIVATION_INITIATION: "activation_initiation",
  ACCESS_LOCATION: "view_location_based_offer",
  ACCESS_LOCATION_CONSET: "location_consent_given"
};

export const CLICKSTREAM_ALLOWED_EVENTS = [
  "page_visit",
  "eligiblePlans_api_call_requested",
  "postpaid_planService_requested",
  "addon_selected",
  "addon_deselected",
  "PreCheckoutForm_submitted",
  "userLoginOTP_api_call_succeeded",
  "userAuthenticate_api_call_succeeded",
  "sim_type_selected",
  "number_type_selected",
  "telco_selected",
  "selectedNumberType_requested",
  "PersonalDetailsForm_submitted",
  "referralCode_api_call_succeeded",
  "numberAndDeliverySlotsAvailability_api_call_succeeded",
  "payment_method_selected",
  "paymentStatus_api_call_succeeded",
  "kyc_api_call_succeeded",
  "manualEkyc_api_call_succeeded",
  "faq_item_clicked",
  "access_location_modal",
  "location_consent_given"
];

export const EVAM_EVENT_NAMES = {
  PLAN_LISTING_PAGE: "view_item_list",
  NUMBER_CATEGORY_SELECTED: "choose_number",
  NUMBER_SUBCATEGORY_SELECTED: "choose_number_premium",
  PLAN_SELECTED: "select_item",
  PLAN_DETAILS_PAGE: "view_item",
  SIM_SELECTED: "sim_type",
  NUMBER_TYPE_SELECTED: "number_type",
  DONOR_TELCO_SELECTED: "number_type_portin_carrier",
  SIM_NUMBER_TYPE_SElECTED: "sim_number_type_selected",
  PORT_IN_NUMBER_ENTERTED: "number_type_portin_number",
  ESIM_CONSENT_CHECK: "sim_type_eSIM_compatibilitycheck",
  BEGIN_CHECKOUT: "begin_checkout",
  PERSONAL_PAGE_VIEW: "view_personal_details_page",
  REFRESH_NUMBER: "refresh_number",
  CONNECTION_DETAILS_PAGE_NEXT: "connection_details_next",
  ADDON_SELECTED: "addon_selected",
  ADDON_DESELECTED: "addon_deselected",
  PREPAID_PACKAGE_SELECTED: "prepaid_package_selected",
  PREPAID_ADDON_DELETED: "prepaid_addon_deleted",
  PLAN_SELECTED_2: "select_item",
  SUBMIT_EMAIL: "submit_email",

  // VERIFICATION_SUBMITTED: "verification_submitted",
  USER_DETAILS_SUBMITTED: "user_details_submitted",
  PROMOCODE_USED: "promocode_used",
  ORDER_SUMMARY_COMPLETED: "order_summary_completed",
  PAYMENT_SELECTED: "payment_selected",
  PAYMENT_DETAILS_SUBMITTED: "payment_details_submitted",
  ORDER_CONFIRMATION: "order_confirmation",
  TAP: "tap",
  KYC_STARTED: "kyc_started",
  KYC_SUBMITTED: "kyc_submitted",
  ACTIVATION_INITIATION: "activation_initiation",
  ACCESS_LOCATION: "view_location_based_offer",
  ACCESS_LOCATION_CONSET: "location_consent_given",
  PAYMENT_METHOD_POPUP: "payment_method_pop_up",
  CLICK_CARDS: "click_cards",
  CLICK_EASYPAISA_LINK_ACCOUNT: "click_easypaisa_link_account",
  CLICK_EASYPAISA_ONETIME: "click_easypaisa_onetime",
  CLICK_JAZZCASH: "click_jazzcash",
  CLICK_BANK_ACCOUNT: "click_bank_account",
  CLICK_OTHER: "click_other",
  CLICK_ALL_MOBILE_WALLET: "click_all_mobile_wallet",
  CLICK_CARDS_WITH_SAVE_METHOD: "click_cards_with_saved_method",
  VIEW_JAZZCASH_INPUT_PAGE: "view_Jazzcash_input_page",
  ENTER_ICCID: "enter_ICCID",
  SCAN_ICCID: "scan_ICCID",
  ACTIVATE_SIM_POST_ICCID: "activate_sim_post_iccid",
  ACTIVATION_STATUS: "activation_status",
  ACTIVATE_SIM_PRE_ICCID: "activate_sim_pre_iccid",
  PURCHASE: "purchase",
  PAYMENT_PENDING: "payment_pending",
  VIEW_EASYPAISA_INPUT_PAGE: "view_easypaisa_input_page",
  PAYMENT_FAILURE: "payment_failure",
  CLICK_EASYPAISA_LINK_ACCOUNT_SAVED: "click_easypaisa_link_account_saved",
  CLICK_EASYPAISA_LINK_ACCOUNT_SAVED_ERROR: "click_easypaisa_link_account_saved_error",
  WEB_LOGIN_EVENT: "web_login_event",
  WEB_LOGOUT_EVENT: "web_logout_event",
  WEB_LOCATION_TOGGLE_ON: "web_toggle_location_on",
  WEB_LOCATION_TOGGLE_OFF: "web_toggle_location_off",
  CNIC_SUBMITTED:"Enter_CNIC",
  ADDRESS_LINE1:"Enter_address_line1",
  SELECT_PROVINCE:"select_province",
  SELECT_CITY: "select_city",
  SELECT_AREA: "select_area",
  SELECT_SLOT_DATE: "Select_slot_date",
  SELECT_SLOT_TIME: "Select_slot_time",
  ENTER_EMAIL: "Enter_email",
  CLICK_VERIFY_EMAIL: "Click_verify_email",
  OTP_VERIFIED: "OTP_verified",
  DETAILS_PAGE_NEXT: "details_page_next",
  VIEW_REVIEW_ORDER: "view_review_order",
  CLICK_EDIT_INFO: "Click_edit_info",
  CLICK_MAKE_PAYMENT: "click_make_payment",
  CLICK_MAKE_PAYMENT_SAVEDMETHOD_CARDS: "click_make_payment_savedmethod_cards",
  CLICK_MAKE_PAYMENT_SAVEDMETHOD_EP: "click_make_payment_savedmethod_ep",
  RE_ENTER_CNIC:"Re_enter_CNIC",
  ENTER_FIRST_NAME:"Enter_first_name",
  ENTER_LAST_NAME:"Enter_last_name",
  ENTER_ALT_NUMBER:"Enter_alternate_number",
  ENTER_DOB:"Enter_DOB",
  CLICK_APPLY_PROMO: "click_apply_promo_code",
  ENTER_PROMO_CODE:"Enter_promo_code",
  NUMBER_SELECTED:"number_selected",
  MAX_5_SIM_POPUP:"max_5_sim_popup"
};

export const EVAM_EVENTS = [
  "page_visit",
  "eligiblePlans_api_call_succeeded",
  "postpaid_planService_requested",
  "prepaid_planService_requested",
  "sim_type_selected",
  "number_type_selected",
  "select_item",
  "number_category_selected",
  "number_subcategory_selected",
  "validatePortInNumber_api_call_succeeded",
  "e_sim_consent_disclaimer_selected",
  "newProfileParameters_api_call_succeeded",
  "refresh_number",
  "addon_selected",
  "shippingMethods_api_call_requested",
  "suggestedAddons_api_call_requested",
  "addon_deselected",
  "PreCheckoutForm_submitted",
  "userLoginOTP_api_call_succeeded",
  "userAuthenticate_api_call_succeeded",
  "telco_selected",
  "selectedNumberType_requested",
  "provice_selected",
  "PersonalDetailsForm_submitted",
  "referralCode_api_call_succeeded",
  "numberAndDeliverySlotsAvailability_api_call_succeeded",
  "payment_method_selected",
  "paymentStatus_api_call_succeeded",
  "kyc_api_call_succeeded",
  "manualEkyc_api_call_succeeded",
  "faq_item_clicked",
  "access_location_modal",
  "location_consent_given",
  "selectedPaymentOption_requested",
  "payment_type_selected",
  "jazzcash_onetime_popup_requested",
  "update_sync_errors",
  "enterICCICManually_requested",
  "activateSimCard_api_call_requested",
  "activateSimCard_api_call_failed",
  "activateSimCard_api_call_succeeded",
  "paymentStatus_api_call_succeeded",
  "paymentStatus_api_call_requested",
  "easypaisa_onetime_popup_requested",
  "paymentMethodInstrument_api_call_failed",
  "userLogout_api_call_requested",
  "requestGuestOtt_api_call_succeeded",
  "location_consent_given",
  "delivery_area_selected",
  "delivery_city_selected",
  "delivery_province_selected",
  "requestGuestOtt_api_call_succeeded",
  "validateGuestOtt_api_call_succeeded",
  "validateGuestOtt_api_call_failed",
  "delivery_slot_full_data_selected",
  "delivery_slot_selected",
  "email_selected",
  "field_blurred",
  "field_touch",
  "select_payment_option_requested",
  "summary_edit_button",
  "PersonalDetailsForm_submitted",
  "addConsentRecord_api_call_requested",
  "dobYear_selected",
  "dob_selected",
  "age_selected",
  "apply_promo_code",
  "promo_enter",
  "lockedNumber_api_call_succeeded",
  "show_max_connection_modal_requested",
  "order_api_call_succeeded"
];

export const flattenData = data => flattenObject(data, "", "->");
